module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_cx-23c7e8f167bae8ad6ea0026fa1ba0f4c.svg";